module.exports = __webpack_public_path__ + "img/Plantosas-cropt.66062635.png";